// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_dy-6";
export var emphasizeQuantity = "_dy-3";
export var flatBottomCorners = "_dy-5";
export var productImage = "_dy-0";
export var quantityContainer = "_dy-2";
export var tooltip = "_dy-1";
export var wrapAndEllipsesOverflow = "_dy-4";